import { observer } from 'mobx-react-lite';
import { DefaultButton, IButtonStyles } from 'office-ui-fabric-react/lib/Button';
import { IContextualMenuProps } from 'office-ui-fabric-react/lib/components/ContextualMenu';
import { IIconProps } from 'office-ui-fabric-react/lib/Icon';
import * as React from 'react';
import { getPalette } from 'owa-theme';

const styles = require('./MeetingActionButton.scss');

export interface MeetingActionButtonProps {
    text: string;
    iconProps: IIconProps;
    secondary?: boolean;
    onClick?: () => void;
    disabled?: boolean;
    menuProps?: IContextualMenuProps;
}

const MeetingActionButton: React.FunctionComponent<MeetingActionButtonProps> = props => {
    const { text, iconProps, secondary, onClick, disabled, menuProps } = props;

    const onButtonClick = React.useCallback(
        (evt: any) => {
            if (onClick) {
                onClick();
            }
            evt.stopPropagation();
        },
        [onClick]
    );

    return (
        <DefaultButton
            className={styles.actionButton}
            text={text}
            styles={calculateCommandButtonCustomStyle(secondary)}
            onClick={onButtonClick}
            iconProps={iconProps}
            disabled={disabled}
            menuProps={menuProps}
        />
    );
};

function calculateCommandButtonCustomStyle(isSecondary: boolean): IButtonStyles {
    const themeSymbols = getPalette();
    const customStyle: IButtonStyles = {
        root: isSecondary
            ? {
                  color: themeSymbols.themePrimary,
                  backgroundColor: 'transparent',
                  borderColor: 'transparent',
                  padding: '0 3px',
              }
            : {
                  color: themeSymbols.themePrimary,
                  backgroundColor: themeSymbols.white,
                  borderColor: themeSymbols.neutralLight,
              },
        label: isSecondary
            ? {
                  fontWeight: 'normal',
              }
            : {},
        rootHovered: {
            color: themeSymbols.neutralPrimary,
            backgroundColor: themeSymbols.neutralLight,
        },

        rootPressed: {
            color: themeSymbols.neutralPrimary,
            backgroundColor: themeSymbols.neutralTertiaryAlt,
        },

        rootExpanded: {
            color: themeSymbols.neutralPrimary,
            backgroundColor: themeSymbols.neutralLight,
        },

        rootExpandedHovered: {
            color: themeSymbols.neutralPrimary,
            backgroundColor: themeSymbols.neutralTertiary,
        },
    };

    return customStyle;
}

export default observer(MeetingActionButton);
